import { map } from "lodash/fp";
import constants from "../../core/constants";
import { multiplyFloatingPointByCurrency } from "../../core/utils";

const COMPENSATION_REGEX = /^\d*(\.\d{1,2})?$/; // Positive number with maximum of two decimals

class VariablePlansPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Variable Plan",
      state: "variableplan",
    };

    this.filters = [
      {
        name: "search",
        title: "Search by name",
        icon: "search",
        isSearch: true,
        resource: "VariablePlan",
        state: "variableplan",
        size: 30,
      },
    ];

    this.fields = [
      { title: "Plan Name", name: "name" },
      { title: "City", name: "cityName" },
      { title: "Bus Type", name: "bustType" },
      { title: "Fuel Compensation per KM", name: "fuel_compensation" },
      {
        title: "Maintenance Compensation per KM",
        name: "maintenance_compensation",
      },
    ];

    this.addOptions = {
      title: "Add New Variable Plan",
      icon: "add",
      fields: [
        { title: "Name", name: "name", isText: true, isRequired: true },
        {
          title: "City",
          name: "city",
          resource: "City",
          isResource: true,
          isRequired: true,
        },
        {
          title: "Bus Type",
          name: "bus_type",
          isResource: true,
          resource: "Bustype",
          isRequired: true,
        },
        {
          title: "Fuel Compensation per KM",
          name: "fuel_compensation",
          isText: true,
          type: "number",
          isRequired: true,
          formatter: multiplyFloatingPointByCurrency,
          pattern: COMPENSATION_REGEX,
          patternErrorMsg:
            "Fuel Compensation must be a minimum of 0 with up to 2 decimal place",
        },
        {
          title: "Maintenance Compensation per KM",
          name: "maintenance_compensation",
          isText: true,
          type: "number",
          isRequired: true,
          formatter: multiplyFloatingPointByCurrency,
          pattern: COMPENSATION_REGEX,
          patternErrorMsg:
            "Maintenance Compensation per KM must be a minimum of 0 with up to 2 decimal place",
        },
      ],
    };
  }

  justify(data) {
    const format = (data) => {
      data.cityName = data.city.name;
      data.bustType = data.bus_type.name;
      data.fuel_compensation = `${
        data.fuel_compensation / constants.currencyBy
      } ${data.currency}`;
      data.maintenance_compensation = `${
        data.maintenance_compensation / constants.currencyBy
      } ${data.currency}`;

      return data;
    };

    return map(format)(data);
  }
}

export default VariablePlansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/variablePlans/variablePlans.transforms.js